import { useTranslation } from 'react-i18next';

const styles = {
  container: 'max-w-[1080px] mx-auto px-4 sm:px-6 lg:px-8 py-6',
  title: 'text-3xl font-bold text-gray-900 mb-10',
  sectionTitle: 'text-lg font-bold text-gray-800 mt-8 mb-2',
  paragraph: 'text-base text-gray-700 mb-4',
  link: 'font-bold'
};

export const TermsAndConditionsPage = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>{t('termsAndConditionsPage.title')}</h1>

      <h2 className={styles.sectionTitle}>{t('termsAndConditionsPage.termsOfUseTitle')}</h2>
      <p className={styles.paragraph}>{t('termsAndConditionsPage.termsOfUseContent1')}</p>
      <p className={styles.paragraph}>{t('termsAndConditionsPage.termsOfUseContent2')}</p>

      <h2 className={styles.sectionTitle}>{t('termsAndConditionsPage.disclaimerTitle')}</h2>
      <p className={styles.paragraph}>{t('termsAndConditionsPage.disclaimerContent')}</p>

      <h2 className={styles.sectionTitle}>{t('termsAndConditionsPage.thirdPartyContentTitle')}</h2>
      <p className={styles.paragraph}>{t('termsAndConditionsPage.thirdPartyContent')}</p>

      <h2 className={styles.sectionTitle}>{t('termsAndConditionsPage.useOfMaterialsTitle')}</h2>
      <p className={styles.paragraph}>{t('termsAndConditionsPage.useOfMaterialsContent')}</p>

      <h2 className={styles.sectionTitle}>{t('termsAndConditionsPage.jurisdictionTitle')}</h2>
      <p className={styles.paragraph}>{t('termsAndConditionsPage.jurisdictionContent')}</p>

      <h2 className={styles.sectionTitle}>{t('termsAndConditionsPage.ownershipOfInformationTitle')}</h2>
      <p className={styles.paragraph}>
        {t('termsAndConditionsPage.ownershipOfInformationContent')}{' '}
        <a href='/?page=privacy' target='_blank' className={styles.link}>
          {t('termsAndConditionsPage.privacyNoticeLinkText')}
        </a>
        .
      </p>
    </div>
  );
};
